import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';

const ToggleButton = ({
  toggleHide,
  isChecked,
  label
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(S.SwitchLabel, null, isChecked === 0 ? /*#__PURE__*/React.createElement(S.SliderInput, {
    type: "checkbox",
    id: "toggleHide",
    onChange: toggleHide(),
    checked: true
  }) : /*#__PURE__*/React.createElement(S.SliderInput, {
    type: "checkbox",
    id: "toggleHide",
    onChange: toggleHide()
  }), label, /*#__PURE__*/React.createElement(S.Slider, {
    className: "slider"
  })));
};

ToggleButton.propTypes = {
  toggleHide: PropTypes.func,
  isChecked: PropTypes.bool,
  label: PropTypes.string
};
export default ToggleButton;